import React from "react";

/**
 * Catches JavaScript errors in child components and displays a fallback UI
 * instead of a blank screen. Helps when chunks fail to load or runtime errors occur.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            fontFamily: "sans-serif",
            textAlign: "center",
            background: "#1a1a2e",
            color: "#fff",
          }}
        >
          <h1 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>
            Something went wrong
          </h1>
          <p style={{ marginBottom: "1.5rem", opacity: 0.8 }}>
            Please try refreshing the page. If the problem persists, try a hard
            refresh (Ctrl+Shift+R or Cmd+Shift+R).
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: "12px 24px",
              fontSize: "16px",
              background: "#6950fb",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
